import { ArrowDown, ArrowUp } from 'lucide-react'
import { FC, PropsWithChildren } from 'react'

interface RatingChange extends PropsWithChildren {
  change: number
}

export const RatingChange: FC<RatingChange> = ({ change, children }) => {
  return (
    <div className="flex justify-center gap-2">
      {children}
      {change >= 0 ? `+${change}` : change}
      {change >= 0 ? <ArrowUp color="green" /> : <ArrowDown color="red" />}
    </div>
  )
}
